var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavorite24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7016 7.05C20.0266 5.475 18.6016 4.5 16.8016 4.5C15.3016 4.5 14.1766 5.1 13.2766 6.225L12.0766 7.65L10.8766 6.225C9.90156 5.1 8.77656 4.5 7.27656 4.5C5.47656 4.5 4.05156 5.475 3.45156 7.05C2.77656 8.625 2.85156 11.025 4.57656 12.75L12.0766 20.25L19.5766 12.75C21.3016 11.025 21.3766 8.625 20.7016 7.05ZM12.0766 5.325C13.0516 4.05 14.5516 3 16.8016 3C22.5016 3 24.3766 10.05 20.5516 13.875L13.0522 21.3744C12.4696 21.9569 11.5298 21.9603 10.9442 21.3809C9.32025 19.7745 6.12006 16.5969 3.45156 13.875C-0.298443 10.05 1.57656 3 7.27656 3C9.52656 3 11.0266 4.05 12.0766 5.325ZM17.3262 9C17.3262 9.41421 16.9904 9.75 16.5762 9.75C16.162 9.75 15.8262 9.41421 15.8262 9C15.8262 8.58579 16.162 8.25 16.5762 8.25C16.9904 8.25 17.3262 8.58579 17.3262 9Z",
    className: "filled",
    fill: "current",
    strokeWidth: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite24);
export default __webpack_public_path__ + "static/media/Favorite-24.b477c76a.svg";
export { ForwardRef as ReactComponent };